var spanishTranslations = {
    translation: {
        actions: {
            cancel: "Cancelar",
            openTab: "Abrir pestaña",
            close: "Cerrar",
        },
        labels: {
            title: "Puntaje de Credito",
            findingYourAccount: "Encontrando Su Cuenta",
        },
        unenrollModal: {
            title: "¿Está seguro de que desea cancelar la inscripción a Su Calificación de Crédito?",
            body: "Si cancela la inscripción, el historial actual de su calificación de crédito ya no estará disponible para que usted lo vea.  Sin embargo, puede inscribirse nuevamente más adelante.",
            stayEnrolled: "Mantener la inscripción",
            unenroll: "Cancelar la inscripción",
        },
        creditStatus: {
            excellent: "Excelente",
            veryGood: "Muy Buena",
            good: "Buena",
            fair: "Regular",
            poor: "Mala",
        },
        creditToolTip: {
            whatDoesCreditScoreMean: "¿Qué significa Su Calificación de Crédito?",
            excellentTitle: "<strong>781 - 850: Excelente - </strong> 40% de la población  <br/>",
            excellentBody: "Típicamente obtendrá las mejores tasas de interés posibles",
            veryGoodTitle: "<strong>720 - 780: Muy Buena - </strong> 20% de la población  <br/>",
            veryGoodBody: "Por lo general, se aprobará en casi cualquier lugar con buenas tasas",
            goodTitle: "<strong>658 - 719: Buena - </strong> 17% de la población  <br/>",
            goodBody: "Probablemente se aprobará con buenas tasas",
            fairTitle: "<strong>601 - 657: Regular - </strong> 14% de la población  <br/>",
            fairBody: "Se le otorgará un préstamo, pero tendrá una tasa de interés elevada",
            poorTitle: "<strong>300 - 600: Mala - </strong> 9% de la población <br/>",
            poorBody: "Solo se le otorgará un préstamo asegurado",
        },
        unenrollSuccessModal: {
            title: "Se ha cancelado su inscripción a Su Calificación de Crédito",
            body: "Puede volver a inscribirse en cualquier momento en el menú de perfil.",
        },
        crossBorderText: "La información compartida en este enlace no forma parte de Synchrony Bank. Tenga en cuenta que, como el sitio al que se dirige no está controlado por Synchrony Bank, usted estará sujeto a los condiciones de uso y la política de privacidad del sitio web que visite.",
        creditScorePage: {
            headerSection: {
                updatedOn: "Actualizada el",
                creditScoreInfo: "Su Calificación de Crédito ha sido actualizada y ahora refleja su calificación e historial de crédito actuales con un modelo actualizado VantageScore 4.0. <strong>Para cualquier pregunta con respecto a su Calificación de Crédito VantageScore, por favor comuníquese con TransUnion LLC llamando al</strong> <link1>(866) 215-1713.</link1>",
                creditScore: "Su Calificación de Crédito",
                score: "Su Calificación",
            },
            buttons: {
                problemWithScore: "¿Ve algún problema en su calificación?",
            },
            problemWithScore: {
                questionsAboutCreditScore: "¿Alguna pregunta sobre Su Calificación de Crédito?",
                aboutCreditScoreAndReasonCodes: 'Su Calificación de Crédito y Códigos de Motivo se proporcionan a Synchrony Bank y reflejan la información contenida en su informe de crédito de TransUnion según la fecha de cálculo (es decir, "a la fecha"). ',
                followStepsText: "<strong>Si cree que esta información no es precisa, puede seguir estos pasos:</strong>",
                stepOne: "Solicite un informe de crédito anual gratuito de TransUnion en <annualCreditLink>www.annualcreditreport.com</annualCreditLink>",
                stepTwo: "Revise su informe",
                stepThree: "Si encuentra información inexacta, <strong>comuníquese con TransUnion</strong> en <transUnionLink>dispute.transunion.com</transUnionLink> o llame al<transUnionPhoneNumber>(800) 916-8800</transUnionPhoneNumber>",
                closeBtnText: "Cerrar",
            },
            links: {
                learnMore: "Conozca más sobre cómo mejorar su calificación de crédito",
                unenroll: "Cancelar la inscripción a Su Calificación de Crédito.",
            },
            headers: {
                affect: "Lo que está afectando su calificación de crédito",
                influences: "Lo que está afectando su calificación de crédito",
                tips: "10 consejos principales para mejorar su calificación de crédito",
            },
            tipColumnOne: [
                "<strong>Siempre</strong> pague puntualmente",
                "Pague por <strong>lo menos el monto mínimo</strong> adeudado",
                "Pague <strong>lo más que pueda</strong> cada mes",
                "Liquide el saldo <strong>total de su tarjeta cada mes</strong>",
                "<strong> Configure alertas de mensajes de texto o de correo electrónico</strong> que le notifiquen su saldo y la fecha de vencimiento.",
                "Configure <strong>pagos automáticos</strong>",
            ],
            tipColumnTwo: [
                "Use solo el <strong>30 - 40%</strong> de su límite de crédito.",
                "Monitoree su informe de crédito y <strong>corrija cualquier inexactitud.</strong>",
                "Solicite nuevo crédito <strong>con moderación</strong>",
                "Establezca <strong>un largo historial de pagos puntuales</strong> y de uso responsable del crédito.",
            ],
            tipModal: {
                summary: "Tener buen crédito significa que usted tiene un <strong>historial de pago puntual de las facturas</strong>. Significa que ha demostrado que <strong>sabe cómo administrar su crédito</strong>. El buen crédito puede ayudarle a obtener mejor <strong>acceso a determinados préstamos y tarjetas de crédito</strong> y por lo general, también a tasas de interés más bajas.",
            },
            influences: [
                {
                    color: "#C42D1E",
                    influenceType: "EXTREMADAMENTE INFLUYENTE",
                    header: "Demasiadas tarjetas bancarias con saldo elevado",
                    body: "Concéntrese en mantener bajo el saldo rotativo, por debajo del 30% de los límites de crédito.",
                },
                {
                    color: "#AC5600",
                    influenceType: " MUY INFLUYENTE",
                    header: "Experiencia y Combinación del Crédito",
                    body: "Es útil mantener una combinación de cuentas (tarjetas de crédito, auto, hipoteca) a lo largo del tiempo para mejorar su calificación.",
                },
                {
                    color: "#CAA416",
                    influenceType: "MODERADAMENTE INFLUYENTE",
                    header: "Historial de Pagos",
                    body: "Asegúrese de pagar todas sus facturas puntualmente.",
                },
                {
                    color: "#2B5C1D",
                    influenceType: "MENOS INFLUYENTE",
                    header: "Antigüedad del Historial de Crédito",
                    body: "Los consumidores con calificaciones elevadas tienen cuentas de crédito abiertas, como tarjetas de crédito al día durante períodos más prolongados.  No cierre sus cuentas más antiguas.",
                },
                {
                    color: "#2B5C1D",
                    influenceType: "MENOS INFLUYENTE",
                    header: "Cuentas Nuevas",
                    body: "No abra demasiadas cuentas nuevas demasiado rápido",
                },
            ],
            disclaimers: {
                thirdParty: "Un tercero brindó esta información y Synchrony Bank no tiene responsabilidad por el contenido provisto.  El contenido provisto está destinado solamente al titular principal de la tarjeta.  Podrá cancelar su inscripción en cualquier momento.  Este programa está sujeto a cambios.",
                transUnion: 'Su Calificación de Crédito y Códigos de Motivo se proporcionan a Synchrony Bank y reflejan la información contenida en su informe de crédito de TransUnion según la fecha de cálculo (es decir, "a la fecha"). <strong>Si usted considera que esta información es inexacta</strong>, puede solicitar a TransUnion un informe de crédito anual gratuito en <link1>www.annualcreditreport.com</link1>. Después de revisar su informe, si encuentra información inexacta, usted puede disputar su informe de crédito de TransUnion en <link2>https://dispute.transunion.com</link2> o llamar a TransUnion al (800) 916-8800.',
                creditRepair: '<strong>Synchrony Bank no es una organización de reparación de crédito</strong> según se define bajo la ley federal y estatal, incluyendo la Ley de Organizaciones de Reparación de Crédito. <strong>Synchrony Bank no proporciona servicios de "reparación de crédito" ni recomendaciones o asistencia sobre "reconstruir" o "mejorar" su informe de crédito, historial de crédito o calificación de crédito.</strong>',
            },
            unenroll: {
                areYouSure: "¿Está seguro de que desea cancelar la inscripción a Su Calificación de Crédito?",
                ifYouUnenroll: "Si cancela la inscripción, el historial actual de su calificación de crédito ya no estará disponible para que usted lo vea. Sin embargo, puede inscribirse nuevamente más adelante.",
                keepMeEnrolled: "Mantener la inscripción",
                unenrollMe: "Cancelar la inscripción",
                youHaveBeenUnenrolled: "Se ha cancelado su inscripción a Su Calificación de Crédito",
                youCanReEnroll: "Puede volver a inscribirse en cualquier momento en el menú de perfil.",
            },
        },
        noCreditScorePage: {
            headerSection: {
                getYouCreditScoreToday: "Obtenga Hoy Su Calificación de Crédito Mensual Gratuita",
            },
            bodySection: {
                subtitle: "Puede obtener acceso a Su Calificación de Crédito con solo tener una cuenta abierta en Synchrony Bank",
                benefits: {
                    transUnion: "Consulte su Calificación de Crédito VantageScore por TransUnion, actualizada mensualmente",
                    influences: "Averigüe qué es lo que más influye en su calificación de crédito",
                    trackCreditScore: "Monitoree su calificación de crédito a lo largo del tiempo",
                    improveCreditScore: "Aprenda cómo puede ayudar a mejorar su calificación de crédito",
                },
                enrollMeButton: "Inscribirme ahora",
                agreement: 'Al hacer clic en "Inscribirme Ahora", usted acepta que Synchrony Bank puede solicitar información a las agencias de informes crediticios para cumplir con este programa y cualquier programa gratuito de información de crédito que lo suceda.  Usted comprende que la información es provista actualmente por TransUnion, un tercero y que Synchrony Bank no asume responsabilidad por el contenido que se provee. Las calificaciones están disponibles en línea solo para titulares de la tarjeta primarios con una cuenta abierta. Podrá anular su inscripción en cualquier momento.  Este programa está sujeto a cambios.',
            },
        },
        errorPage: {
            anyAccountsQualify: "No tiene ninguna cuenta abierta que califique para Su Calificación de Crédito.",
            creditScoreNotAvailable: "Su Calificación de Crédito actualmente no está\ndisponible",
            mobileTitle: "Nos Disculpamos",
            title: "Estamos teniendo dificultades técnicas",
            description: "Por favor, intente nuevamente más tarde.",
            subTitle: "En este momento, estamos teniendo dificultades técnicas y no podemos acceder a Su Calificación de Crédito.",
            accountManager: "Administrador de cuenta",
        },
    },
};
export default spanishTranslations;
